import { render } from "./sales-receipt-cash.vue?vue&type=template&id=6a31944f&scoped=true"
import script from "./sales-receipt-cash.vue?vue&type=script&lang=js"
export * from "./sales-receipt-cash.vue?vue&type=script&lang=js"

import "./sales-receipt-cash.vue?vue&type=style&index=0&id=6a31944f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a31944f"]])

export default __exports__